import axios from 'axios';
import Environment from '../../utils/Environment';
import { StoreOrderHistoryDTO } from '../../common/tab/dto/StoreOrderHistoryDTO';

const getStoreOrderHistory = async (
  page: number,
  size: number,
  setIsLoading: (val: boolean) => void,
  setData: (val: StoreOrderHistoryDTO[]) => void,
  setTotalPages: (val: number) => void
) => {
  const apiURL = `${Environment.getStoreOrderHistoryAPI()}?page=${page}&size=${size}`;
  setIsLoading(true);
  try {
    const response = await axios.get(apiURL);
    setData(response.data.content); 
    setTotalPages(response.data.totalPages); 
  } catch (err) {
    console.error('Error:', err);
  } finally {
    setIsLoading(false);
  }
};

export default getStoreOrderHistory;
